import { authAxios } from '../default';

export const settingsApi = {
  fetchInventorySettings: async (): Promise<any> => {
    return authAxios.get('/api/settings');
  },

  postInventorySettings: async (data: any): Promise<any> => {
    return authAxios.post('/api/settings', data);
  },
};
